// extracted by mini-css-extract-plugin
export default {"ContentSliderWrapper":"RelatedChannel_ContentSliderWrapper__WzdKb","Content":"RelatedChannel_Content__aU65R"};